/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ConsultaAlteracaoLocalizacaoAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AVATAR_BENEFICIARIO = 'avatar-beneficiario',
  CONTEXTUAL_BAR_ALTERACAO_LOCALIZACAO = 'contextual-bar-alteracao-localizacao',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK_0 = 'deck-0',
  FETCH_0 = 'fetch-0',
  FETCH_CONSULTA = 'fetch-consulta',
  FETCH_SITUACOES = 'fetch-situacoes',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_6 = 'field-6',
  FIELD_BENEFICIARIO = 'field-beneficiario',
  FIELD_DATA_APROVACAO = 'field-data-aprovacao',
  FIELD_DATA_SOLICITACAO = 'field-data-solicitacao',
  FIELD_LOCALIAZACAO = 'field-localiazacao',
  FIELD_SITUACOES = 'field-situacoes',
  FILTER_CONSULTA = 'filter-consulta',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  HPMS_DYNAMIC_CONTENT_SITUACAO = 'hpms-dynamic-content-situacao',
  INPUT_0 = 'input-0',
  LOCATOR_BENEFICIARIO = 'locator-beneficiario',
  LOCATOR_FIELD_0 = 'locator-field-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_BENEFICIARIO = 'mapper-beneficiario',
  PANEL_ALTERACAO_LOCALIZACAO = 'panel-alteracao-localizacao',
  TEXT_1 = 'text-1',
  TEXT_DATA_APROVACAO = 'text-data-aprovacao',
  TEXT_DATA_SOLICITACAO = 'text-data-solicitacao',
  TEXT_LOCALIZACAO = 'text-localizacao',
}
export { ConsultaAlteracaoLocalizacaoAliases };
